import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  body: {
    backgroundColor: theme.tokens.colors.bg.greyscale.primary,
  },
  text: {
    borderRadius: theme.tokens.radius.s,
  },
  rect: {
    borderRadius: theme.tokens.radius.l,
  },
  circle: {
    borderRadius: theme.tokens.radius.round,
  },
}));
